import React, { Fragment } from "react";
import { Label, Input } from "reactstrap";
import "./ToggleSwitch.css";

export const ToggleSwitch = ({
  label,
  value,
  defaultChecked,
  onChange,
  disabled = false,
  size,
}) => (
  <Fragment>
    {label && <Label className="label text-left">{label}</Label>}
    <Label
      id="toggle-switch-wrapper"
      className={`switch switch-text switch-pill switch-secondary switch-${size}`}
      style={{ marginBottom: "0px", verticalAlign: "middle" }}
    >
      <Input
        type="checkbox"
        className="switch-input text-right"
        onChange={onChange}
        value={value}
        defaultChecked={defaultChecked}
        disabled={disabled}
      />
      <span
        id="toggle-switch-bg"
        className="switch-label"
        data-on=""
        data-off=""
      ></span>
      <span
        id="toggle-switch-handle"
        className={`switch-handle ${value ? "checked" : ""}`}
      ></span>
    </Label>
  </Fragment>
);
